@if (iconSet()) {
  <div class="info-icon pl-1 mt-2 {{tooltipClass()}}"><img [matTooltipPosition]="tooltipPosition()" alt="Information"
    [matTooltip]="tooltipInfo()" matTooltipClass="blue-tooltip" data-cy="tooltipIcon"
    src="{{iconSet()?.['icon.section.info']}}">
  </div>
}